<template>
  <input
    v-model="inputValue"
    v-bind="mutatedAttrs"
    type="text"
    class="
      block
      w-full
      sm:text-sm
      dark:text-gray-100
      bg-white
      dark:bg-gray-700 dark:bg-opacity-70
      rounded-md
      border
      dark:border-gray-950
      focus:ring-indigo-500
      focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-black
      shadow-sm
    "
    :class="{
      'cursor-not-allowed': mutatedAttrs.disabled
    }"
  >
</template>

<script>
import {
  defineComponent,
  useAttrs,
  computed,
  toRefs,
} from "vue"

export default defineComponent({
  name: "UiInput",

  props: ["modelValue"],

  emits: ["update:modelValue"],

  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const attrs = useAttrs();

    const mutatedAttrs = computed(() => {
      const _attrs = {
        ...attrs
      };

      if (_attrs.onInput) {
        const onInput = (event) => {
          attrs.onInput(event.target.value);
        }
        _attrs.onInput = onInput;
      }

      return _attrs;
    });

    const inputValue = computed({
      get() {
        return modelValue.value;
      },

      set(value) {
        emit("update:modelValue", value);
      },
    });

    return {
      inputValue,
      mutatedAttrs,
    }
  },
});
</script>

<style scoped>
</style>
